// src/services/solicitudes.js
import { api } from "./api";

/**
 * Construye querystring ignorando undefined/null/""
 * (booleans y 0 sí se envían).
 */
const qs = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") q.set(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : "";
};

/**
 * Normaliza la respuesta del backend:
 * - Nuevo backend: { items, total, page, per_page, kpi }
 * - Legacy: [ ...items ]
 */
const normalizeListado = (res) => {
  if (Array.isArray(res)) {
    return {
      items: res,
      total: res.length,
      page: 1,
      per_page: res.length,
      kpi: null,
    };
  }
  const items = res?.items ?? [];
  return {
    items,
    total: Number(res?.total ?? items.length ?? 0),
    page: Number(res?.page ?? 1),
    per_page: Number(res?.per_page ?? items.length ?? 0),
    kpi: res?.kpi ?? null,
  };
};

/**
 * GET /api/solicitudes
 * Nota: si tu api base ya añade el prefijo /api,
 * este path '/solicitudes' es correcto.
 */
export async function listarSolicitudes(
  token,
  {
    usuario,
    estado, // "pendiente" | "aprobada" | "rechazada"
    tipo, // "entrada" | "salida"
    desde, // "YYYY-MM-DD"
    hasta, // "YYYY-MM-DD"
    q, // búsqueda libre
    page = 1,
    per_page = 50,
    order_by = "timestamp",
    order_dir = "desc",
    solo_pendientes = false,
  } = {}
) {
  const res = await api.get(
    `/solicitudes${qs({
      usuario,
      estado,
      tipo,
      desde,
      hasta,
      q,
      page,
      per_page,
      order_by,
      order_dir,
      solo_pendientes,
    })}`,
    token
  );
  return normalizeListado(res);
}

/** GET /api/solicitudes/:id */
export function obtenerSolicitud(token, id) {
  return api.get(`/solicitudes/${id}`, token);
}

/** POST /api/solicitudes  (crear solicitud manual) */
export function crearSolicitud(token, { fecha, hora, tipo, motivo }) {
  return api.post(
    `/solicitudes`,
    { fecha, hora, tipo, motivo: motivo ?? "" },
    token
  );
}

/** POST /api/solicitudes/:id/aprobar */
export function aprobarSolicitud(token, id) {
  // Enviamos {} (no null) para evitar problemas con parsers
  return api.post(`/solicitudes/${id}/aprobar`, {}, token);
}

/** POST /api/solicitudes/:id/rechazar */
export function rechazarSolicitud(token, id, motivo) {
  return api.post(
    `/solicitudes/${id}/rechazar`,
    { motivo: motivo ?? "" },
    token
  );
}

export default {
  listarSolicitudes,
  obtenerSolicitud,
  crearSolicitud,
  aprobarSolicitud,
  rechazarSolicitud,
};
